import { Controller } from "@hotwired/stimulus"

// Stimulus controller for password visibility toggle and debounced validation
export default class extends Controller {
  static targets = ["input", "toggle", "feedback"]

  connect() {
    console.log("connected to password input controller")
    this.toggleTarget.innerHTML = this.inputTarget.type === "password"
      ? "<i class='fa fa-eye fa-fw'></i>"
      : "<i class='fa fa-eye-slash fa-fw'></i>"
    this.debounceTimeout = null
    // Use Stimulus event binding instead of addEventListener
    this.validate() // Run initial validation in case of prefilled value
  }

  // Stimulus action for input event
  validate(event) {
    // Validate password according to new rules: 12-72 chars, at least one number, at least one symbol, allowed chars only
    const value = (event && event.target) ? event.target.value : this.inputTarget.value
    clearTimeout(this.debounceTimeout)
    this.debounceTimeout = setTimeout(() => {
      let message = ""
      let valid = true
      const allowedPattern = /^[\w\d\-!@#$%&*?]+$/
      const hasNumber = /\d/
      const hasSymbol = /[!@#$%&*?]/
      if (value.length > 0 && value.length < 12) {
        message = "Password must be at least 12 characters."
        valid = false
      } else if (value.length > 72) {
        message = "Password must be no more than 72 characters."
        valid = false
      } else if (!allowedPattern.test(value)) {
        message = "Password may only contain letters, numbers, dashes, and !@#$%&*?"
        valid = false
      } else if (!hasNumber.test(value)) {
        message = "Password must include at least one number."
        valid = false
      } else if (!hasSymbol.test(value)) {
        message = "Password must include at least one symbol (!@#$%&*?)."
        valid = false
      } else {
        message = "Password is valid."
        valid = true
      }
      if (this.hasFeedbackTarget) {
        this.feedbackTarget.textContent = message
        this.feedbackTarget.classList.toggle('text-danger', !valid)
        this.feedbackTarget.classList.toggle('text-success', valid)
      }
    }, 300)
  }

  toggle() {
    if (this.inputTarget.type === "password") {
      this.inputTarget.type = "text"
      this.toggleTarget.innerHTML = "<i class='fa fa-eye-slash fa-fw'></i>"
    } else {
      this.inputTarget.type = "password"
      this.toggleTarget.innerHTML = "<i class='fa fa-eye fa-fw'></i>"
    }
  }
}
